<template>
    <div>
        <template v-if="!error">
            <seamless-access-button :redirect="redirectTo + '/satosa'" class="mb-4" />
            <google-oauth-btn :redirect="redirectTo + '/google'">Sign up with Google</google-oauth-btn>
            <div class="d-flex align-center mt-5 mb-2">
                <v-divider />
                <span class="caption px-2">OR</span>
                <v-divider />
            </div>
            <email-signup-form
                @verifiedEmail="signup"
                :loading="sendingInvitation"
                :emailDomainWhitelist="emailDomainWhitelist"
                class="mt-4"></email-signup-form>
        </template>
        <template v-else>
            <v-alert dense text type="error" class="ma-0 font-weight-bold text-left pt-4">{{ error }}</v-alert>
        </template>
    </div>
</template>

<script>
const SeamlessAccessButton = () => import('@/components/SeamlessAccessButton.vue')
const GoogleOauthBtn = () => import('@/components/GoogleOauthBtn.vue')
const EmailSignupForm = () => import('@/modules/invitations/components/EmailSignupForm.vue')

export default {
    name: 'SignupOptions',
    components: { SeamlessAccessButton, GoogleOauthBtn, EmailSignupForm },
    props: {},
    data() {
        return {
            sendingInvitation: false,
            redirectTo: '',
            emailDomainWhitelist: [],
            error: ''
        }
    },
    created() {
        this.redirectTo = this.$route.path.substring(0, this.$route.path.lastIndexOf('/'))
    },
    methods: {
        async signup(info) {
            try {
                this.sendingInvitation = true
                const { data } = await this.$axios.post(`/invitations/invgen/${this.$route.params.token}`, {
                    email: info.email,
                    g_recaptcha_response: info.recaptchaToken
                })
                this.emailDomainWhitelist = data.email_domain_whitelist

                if (data?.url !== null) {
                    this.sendingInvitation = false
                    this.$nextTick(() => {
                        const pathname = new URL(data.url).pathname
                        const type = this.$route.params.type ? `/${this.$route.params.type}` : ''
                        const url = `${window.location.origin}${pathname}${type}`
                        this.$router.push(url)
                    })
                } else {
                    this.$router.push({
                        name: 'signup-success'
                    })
                }
            } catch (error) {
                this.$emit('error')
                if (error?.response?.data?.code === 'create_instances_with_single_editor_failed') {
                    this.error =
                        'A sign up request has already been sent to the provided email address, please check the email box or contact support@alphacruncher.com'
                } else if (error?.response?.data?.code === 'instance_already_exists') {
                    this.error = 'An instance associated with this email address has already been created, please try to login to Nuvolos with this email.'
                    window.setTimeout(() => {
                        this.$router.push({ name: 'login', query: { login_hint: info.email } })
                    }, 5000)
                } else if (error?.response?.data?.code === 'invitation_generator_has_expired') {
                    this.error = 'This invitation generator has expired. Please contact your lecturer or TA to get a valid invitation.'
                } else if (error?.response?.data?.code === 'email_domain_not_in_whitelist') {
                    this.error = 'The provided email domain is not supported, please use another one.'
                } else if (error.response?.data?.code === 'email_validation_failed') {
                    this.error = 'We could not verify your email as an academic e-mail address, please use the e-mail address of your institution.'
                } else {
                    this.error = 'Sign-up request failed'
                }
            } finally {
                this.sendingInvitation = false
            }
        }
    }
}
</script>
